export const logRetentionDays = 7;
